const initialState = {
  requesting: true,
  data: {
    loading: true,
  },
  freight_forwarder_company_list: [],
  view_details: {},
  retrieveDetails: [],
  assignedList: [],
  unassignedList: []
};

export const airlineAdminSpotRateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'RETRIEVE_SPOT_RATE':
      return {
        ...state,
        requesting: false,
        data: {
          loading: false,
          ...payload,
        },
      };

    case 'RETRIEVE_FREIGHT_FORWARDER_COMPANY_LIST':
      return {
        ...state,
        requesting: false,
        freight_forwarder_company_list: [...payload],
      };
    case 'RETRIEVE_FILTERED_SPOT_RATE':
      return {
        ...state,
        requesting: false,
        data: {
          loading: false,
          ...payload,
        },
      };
    case 'VIEW_AIRFARE_DETAILS':
      return {
        ...state,
        requesting: false,
        view_details: payload,
      };
    // GET_ASSIGNED_LIST_SUCCESS_AIRLINE_ADMIN
    case 'GET_ASSIGNED_LIST_SUCCESS_AIRLINE_ADMIN':
      return {
        ...state,
        requesting: false,
        assignedList: payload,
      };

    case 'GET_UNASSIGNED_LIST_SUCCESS_AIRLINE_ADMIN':
      return {
        ...state,
        requesting: false,
        unassignedList: payload,
      };

    case 'RETRIEVE_AIRFARE_RECORD':
      return {
        ...state,
        requesting: false,
        retrieveDetails: payload,
      };
    default:
      return state;
  }
};
